module.exports = __webpack_public_path__ + "assets/media/5.cc681e51.wav";